import { Screen } from "../components/Screen";

/**
 * п.17 ТЗ. Каркас закладено в нижній навігації й дизайн-системі (п.27 — стан через
 * Telegram CloudStorage вже підключено в state/store.ts); повна реалізація "♡ Зберегти"
 * по картках і списку обраного — наступна ітерація (Етап 6-8 ТЗ), щоб не розтягувати
 * поточний MVP.
 */
export function Favorites() {
  return (
    <Screen title="Обране">
      <div className="empty-state">
        <div className="empty-state-icon">♡</div>
        Розділ "Обране" з'явиться в наступному оновленні — зможете зберігати авто, що вас
        зацікавили, і повертатись до них.
      </div>
    </Screen>
  );
}
